import { later } from '@ember/runloop';
import { service } from '@ember/service';
import HotelSettingsCompetitorsRoute from 'lumen/routes/hotel/settings/competitors';

export default class HotelSettingsCompetitorsGeneralRoute extends HotelSettingsCompetitorsRoute {
  queryParams = {
    activeTab: {
      refreshModel: false,
    },
  };

  @service alerting;
  @service intl;

  beforeModel() {
    if (!this.access.hasAppCompset && !this.access.hasRmsCompset) {
      this.router.transitionTo('hotel.settings.index');
    }
  }

  async onRouteWillChange(controller, transition) {
    if (
      transition.to.name !== 'hotel.settings.competitors.general' &&
      controller.hasUnsavedChanges
    ) {
      transition.abort();

      const isCancelConfirmed = await this.alerting.showConfirmWarningAlert({
        dangerMode: true,
        title: this.intl.t('general.unsaved_changes.title'),
        text: this.intl.t('general.unsaved_changes.description'),
        buttons: {
          cancel: {
            text: this.intl.t('general.cancel'),
          },
          confirm: {
            text: this.intl.t('general.discard_changes'),
          },
        },
      });

      if (isCancelConfirmed) {
        controller.setHasUnsavedChanges(false);
        transition.retry();
      }
    }

    if (
      transition.to.name !== 'hotel.settings.competitors.general' &&
      !controller.hasUnsavedChanges &&
      controller.hasSavedChanges
    ) {
      // Refresh page as otherwise the compset doesn't update properly ...
      // TODO: actual proper fix by making sure the compet data changes propagate to the other apps
      // ref: https://otainsight.atlassian.net/browse/SH-16475
      transition.then(() => {
        // Use `later` to avoid refreshing the page before the transition is complete
        // eslint-disable-next-line ember/no-runloop
        later(() => window.location.reload());
      });
    }
  }

  resetController(controller, isExiting, transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      this.router.off('routeWillChange', this.transitionHandler);
      this.transitionHandler = null;
    }
  }

  setupController(controller, model, transition) {
    super.setupController(controller, model, transition);

    this.transitionHandler = (t) => {
      this.onRouteWillChange(controller, t);
    };

    this.router.on('routeWillChange', this.transitionHandler);
  }
}
